import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Brand } from "../../../types";
import { BrandFormProps } from "../types/brands-types";
import { brandSchema, BrandFormData } from "../../../schemas/forms";
import { ControlledTextField } from "../../../components/form";
import { useEffectiveBranchId } from "../../../hooks/use-effective-branch-id";

export const BrandForm: React.FC<BrandFormProps> = ({
  onSubmit,
  initialValues,
  isLoading = false,
  onCancel,
}) => {
  const effectiveBranchId = useEffectiveBranchId();

  const form = useForm<BrandFormData>({
    resolver: zodResolver(brandSchema),
    defaultValues: {
      name: initialValues?.name || "",
    },
  });

  const handleFormSubmit = async (data: BrandFormData): Promise<void> => {
    // Convert form data to Brand format
    const brandData: Partial<Brand> = {
      name: data.name,
      ...(effectiveBranchId && !initialValues && { branchId: effectiveBranchId }),
    };
    await onSubmit(brandData);
  };

  return (
    <form
      onSubmit={form.handleSubmit(handleFormSubmit)}
      className="form-space-y-2"
    >
      <ControlledTextField
        control={form.control}
        name="name"
        label="Название бренда"
        placeholder="Введите название бренда"
        required
        disabled={isLoading}
      />

      <div className="form-wrapper__actions">
        <button
          type="submit"
          className="form-button form-button--primary form-button--full"
          disabled={isLoading}
        >
          {isLoading
            ? "Загрузка..."
            : initialValues
            ? "Сохранить изменения"
            : "Добавить бренд"}
        </button>
      </div>
    </form>
  );
};
